module.exports = __webpack_public_path__ + "static/media/chengxiaochen.2f2d3897.png";